/**
 * The wishlist integrations JS functionality.
 */

class sizeguide {
	constructor() {
		wp.hooks.addAction( 'qalaBuy.action.after_quickview_populated', 'addSizeguideListener', this.addListener );
		document.addEventListener( 'DOMContentLoaded', () => {
			this.addLightboxToggle();
		} );
	}

	/**
	 * Populates the wishlist template with the content.
	 *
	 * @param {Object} productData
	 * @param {Object} quickview
	 */
	addListener = ( productData, quickview ) => {
		const link = quickview.modal.querySelector( '.sizeguide__link' );
		const lightbox = document.body.querySelector( '.qala-quickview__lightbox' );

		if ( ! link || ! lightbox ) {
			return;
		}

		link.addEventListener( 'click', event => {
			event.preventDefault();
			const imageURL = link.href;
			const lightboxImage = lightbox.querySelector( '.lightbox-image' );
			lightboxImage.style.backgroundImage = 'url("' + imageURL + '")';
			lightbox.classList.toggle( 'qala-quickview__lightbox--active' );
		} );
	};

	/**
	 * Adds a toggle to the lightbox itself.
	 *
	 * This ensures that clicking it will close itself.
	 */
	addLightboxToggle = () => {
		const lightbox = document.body.querySelector( '.qala-quickview__lightbox' );
		lightbox.addEventListener( 'click', () => {
			lightbox.classList.toggle( 'qala-quickview__lightbox--active' );
		} );
	};
}

export default sizeguide;
